import { joinParts } from './utils'

export const analytics = {
  event: (codeUrl?: string) =>
    codeUrl ? joinParts('tracking', 'manage', 'event', codeUrl) : joinParts('tracking', 'manage', 'event'),
  transaction: (transactionCode: string) => joinParts('tracking', 'manage', 'userTransaction', transactionCode),
}
